import { render, staticRenderFns } from "./OrderEditCard.vue?vue&type=template&id=0f627445&"
import script from "./OrderEditCard.vue?vue&type=script&lang=js&"
export * from "./OrderEditCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderEditCard.vue?vue&type=style&index=0&id=0f627445&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports